export const SectionPartners = () => {
  return (
    <section className="animate-pop-up flex w-full flex-col gap-8 p-8 py-12 text-center">
      <h2 className="text-3xl font-semibold text-primaria-claro">CONHEÇA NOSSOS PARCEIROS!</h2>
      <ul className="flex flex-col gap-8">
        <div className="grid grid-cols-2 items-center justify-center gap-8 md:grid-cols-4">
          <li className="grid place-items-center">
            <img
              alt=""
              loading="lazy"
              decoding="async"
              data-nimg="1"
              className="h-fit w-fit bg-transparent"
              src="/projeto/parceiro1.webp"
            />
          </li>
          <li className="grid place-items-center">
            <img
              alt=""
              loading="lazy"
              decoding="async"
              data-nimg="1"
              className="bg-transparent"
              src="/projeto/parceiro2.webp"
            />
          </li>
          <li className="grid place-items-center">
            <img
              alt=""
              loading="lazy"
              width="120"
              height="120"
              decoding="async"
              data-nimg="1"
              className="bg-transparent"
              src="/projeto/parceiro3.webp"
            />
          </li>
          <li className="grid place-items-center">
            <img
              alt=""
              loading="lazy"
              decoding="async"
              data-nimg="1"
              className="bg-transparent"
              src="/projeto/parceiro4.webp"
            />
          </li>
        </div>
        <div className="grid grid-cols-2 items-center justify-center gap-8 md:grid-cols-3">
          <li className="grid place-items-center">
            <img
              alt=""
              loading="lazy"
              decoding="async"
              data-nimg="1"
              className="bg-transparent"
              src="/projeto/parceiro5.webp"
            />
          </li>
          <li className="grid place-items-center">
            <img
              alt=""
              loading="lazy"
              width="120"
              height="120"
              decoding="async"
              data-nimg="1"
              className="bg-transparent"
              src="/projeto/parceiro6.webp"
            />
          </li>
          <li className="grid place-items-center">
            <img
              alt=""
              loading="lazy"
              decoding="async"
              data-nimg="1"
              className="bg-transparent"
              src="/projeto/parceiro7.webp"
            />
          </li>
        </div>
      </ul>
    </section>
  );
};
